import React from "react";
import { IGrpZoneamento } from "../../../../../shared/interfaces/IProperties";
import { DivisorPeB } from "../../divisor";
import { decodeAndSplitTrace } from "../../helpers/decodeAndSplitTrace";

interface Props {
    zoneamento?: IGrpZoneamento;
}

export const AraucariaUsoSolo: React.FC<Props> = ({ zoneamento }) => {
    const permit = zoneamento?.permitidas;
    const permitidas = permit?.replace(/(<([^>]+)>)/gi, "");
    const permis = zoneamento?.permissivas;
    const permissivas = permis?.replace(/(<([^>]+)>)/gi, "");
    const probid = zoneamento?.proibidas;
    const proibidas = probid?.replace(/(<([^>]+)>)/gi, "");

    return (
        <>
            <br />
            <DivisorPeB />
            <div className="text-center">
                <h3>
                    PARÂMETROS DE USO DO SOLO - Anexo V da Lei Complementar
                    n°25/2020
                </h3>
            </div>
            <br />
            <div className="text-left">
                <p className="font-bold">Usos adequados:</p>
                {permitidas && <span>{decodeAndSplitTrace(permitidas)}</span>}
            </div>
            <br />
            <div className="text-left">
                <p className="font-bold">Usos permissivos:</p>
                {permissivas && <span>{decodeAndSplitTrace(permissivas)}</span>}
            </div>
            <br />
            <div className="text-left">
                <p className="font-bold">Usos proibidos:</p>
                {proibidas && <span>{decodeAndSplitTrace(proibidas)}</span>}
            </div>
            <br />
        </>
    );
};
